import { render, staticRenderFns } from "./productClassify.vue?vue&type=template&id=2836cad6&scoped=true&"
import script from "./productClassify.vue?vue&type=script&lang=js&"
export * from "./productClassify.vue?vue&type=script&lang=js&"
import style0 from "./productClassify.vue?vue&type=style&index=0&id=2836cad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836cad6",
  null
  
)

export default component.exports